import { Component } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
    selector: 'app-mainlayout',
    standalone: true,
    templateUrl: './mainlayout.component.html',
    imports: [HeaderComponent, SidebarComponent]
})
export class MainlayoutComponent {
}
